import React, { FC } from 'react';
import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import CentsLoader from 'components/common/centsLoader/CentsLoader';
import { getSalesforceId, SalesforceConfig } from 'api/admin/businesses/billing/getSalesforceId';
import { ApiError } from 'types/api';
import styles from './BillingConfiguration.module.scss';
import { BusinessConfigurationForm } from './BusinessConfigurationForm';

export const BillingConfiguration: FC<{
  businessId: number;
}> = ({ businessId }) => {
  const { data, isLoading, refetch } = useQuery<unknown, ApiError, SalesforceConfig>({
    queryKey: ['getBilling', { businessId }],
    queryFn: async () => {
      const { data } = await getSalesforceId(businessId);
      return data;
    },
    onError: (error) => {
      Sentry.captureException(error);
      toast.error(error?.response?.data?.error ?? 'An error occurred while getting billing data');
    },
  });

  if (isLoading) {
    return (
      <div className={styles.container}>
        <CentsLoader />
      </div>
    );
  }

  if (typeof data?.salesforceId !== 'undefined') {
    return (
      <div className={styles.container}>
        <BusinessConfigurationForm
          businessId={businessId}
          currentSalesforceId={data.salesforceId}
          refetchId={refetch}
        />
      </div>
    );
  }

  return <h2>Something went wrong</h2>;
};
